import { useState, useEffect } from "react";
import { API_URL } from "../../../constants";
import { GetServiceCaller } from "../../../services/serviceCaller";
import Dynamic_PR_table from "../../../components/Dynamic_PR_table";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../constants/layout/store/filterSlice";

const TeamPerformanceEvaluationReport = () => {

  const navigate = useNavigate()
  const [reportList, setReplortList] = useState([]);
  const [appraisalCycle, setAppraisalCycle] = useState([]);
  const [employee, setemployee] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);
  const [apiStatus, SetApiStatus] = useState(undefined);

  useEffect(() => {
    fetchReportList();
  }, [searchTerm]);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Team Performance Evaluation Report"))
  }, [])

  const fetchReportList = async () => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}pr-report/1?P_AppraisalCycleID=${0}&P_EmployeeID=${0}`
      );
      setReplortList(response?.data?.data?.header);

      const appraisalOpts = response?.data?.data?.appraisalCycle.map((tech) => ({
        value: tech.value,
        label: tech.text,
      }));
      appraisalOpts.unshift({ value: 0, label: "Select..." });
      setAppraisalCycle(appraisalOpts);

      const employeeOpts = response?.data?.data?.employee.map((tech) => ({
        value: tech.value,
        label: tech.text,
      }));

      employeeOpts.unshift({ value: 0, label: "Select..." });
      setemployee(employeeOpts);
      SetApiStatus(response?.status);
    } catch (error) {
      console.error("Error fetching reports", error);
    }
  };
  const columns = {
    AppraisalCycle: { text: "Appraisal Cycle", visible: true  },
    Employee: { text: "Employee", visible: true  },
    EvaluationDate: {
      text: "Evaluation Date",
      align: "center",
      format: "date",
      visible: true 
    },
    EmployeeRating: { text: "Employee Rating", align: "center", visible: true  },
    ReviewDate: { text: "Review Date", align: "center", format: "date", visible: true  },
    ReviewerRating: { text: "Reviewer Rating", align: "center", visible: true  },
    Status: { text: "Status", align: "center", visible: true  },
  }; 
  const handleView = (id) => {
    navigate(`/team-evaluation-report/${id.ID}`);
  };

  const formDatas = [
    {
      name: "Appraisal Cycle",
      type: "Select",
      options: [...appraisalCycle],
    },

    {
      name: "Employee",
      type: "Select",
      options: [...employee],
    },
  ];

  const handleGetData = async () => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}pr-report/1?P_AppraisalCycleID=${
          filterFormData.find((o) => o.label === "Appraisal Cycle")
            ? filterFormData.find((o) => o.label === "Appraisal Cycle").value
            : 0
        }&P_EmployeeID=${
          filterFormData.find((o) => o.label === "Employee")
            ? filterFormData.find((o) => o.label === "Employee").value
            : 0
        }`
      );
      if (response.status === 200) {
        const cleanedData = response.data.headers;
        setReplortList(response?.data?.data?.header);
        setLoading(false);
      } else {
        console.error(
          "Failed to fetch partnerMaster. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching PartnerMaster:", error);
    }
  };

  const [filterFormData, setFilterData] = useState([]);

  const handleChange = (e, name) => {

    setFilterData((prevFormData) => {
      // Check if the label already exists
      const existingLabelIndex = prevFormData.findIndex(
        (item) => item.label === name
      );

      // If the label exists, update its value
      if (existingLabelIndex !== -1) {
        const updatedFormData = prevFormData.map((item, index) =>
          index === existingLabelIndex
            ? { ...item, value: e.value !== undefined ? e.value : e }
            : item
        );
        return updatedFormData;
      } else {
        // If the label doesn't exist, add a new label-value pair
        return [
          ...prevFormData,
          {
            label: name,
            value: e.value !== undefined ? e.value : e, // Assuming e is an event object
          },
        ];
      }
    });
  };

  const handleFilterReset = () => {
  // Reset to empty/default values without passing any specific data
  setFilterData([]);
  handleGetData();
};

  return (
    <>
        <div className="container-fluid" id="skill_section">
          <div className="container-fluid" id="skill-table-area">
              <Dynamic_PR_table
                data={reportList}
                columns={columns}
                itemsPerPage={8}
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
                isActionRequired={true}
               isApiStatus={apiStatus}
              isRequiredStatus={true}
                isAddNewBtnRequired={false}
                showIcon3={true}
                formDatas={formDatas}
                filterFormData={filterFormData}
                handleGetData={handleGetData}
                handleChange={handleChange}
                isFilterRequired={true}
                showIcon4={false}
                showIcon5={false}
                handleIcon3={handleView}
                handleReset={handleFilterReset}
                icons={{
                  Icon1: <i class="bi bi-pencil-square icons"></i>,
                  Icon1Text: " Edit",
                  Icon2: <i class="bi bi-trash-fill icons"></i>,
                  Icon3: <i class="bi bi-eye-fill icons"></i>,
                  Icon3Text: "View",
                  Icon4: <i class="bi bi-plus-square icons"></i>,
                  Icon4Text: " Add Sub-Contractor",
                }}
              />
     
          </div>
        </div>
    </>
  );
};

export default TeamPerformanceEvaluationReport;
